import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";
import { ARTICULO } from "../ventas/types";

type HistoricoContext = ActionContext<ARTICULO, RootState>;
type HistoricoActionTree = ActionTree<ARTICULO, RootState>;

export const actions: HistoricoActionTree = {
  async listarArticulos(context: HistoricoContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Historico/ListarHistoricoCliente",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
};
